import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import getRarityInfo, { formatPercent } from '../../common/helpers/getRarityInfo';
export default class BadgeModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "badge", void 0);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "earnedUsers", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.badge = this.attrs.badge;
    this.loadEarnedUsers();
  }
  async loadEarnedUsers() {
    this.loading = true;
    m.redraw();
    try {
      const userBadges = await app.store.find('user-badges', {
        filter: {
          badge: String(this.badge.id())
        },
        include: 'user',
        sort: '-earnedAt',
        page: {
          limit: 20
        }
      });
      this.earnedUsers = userBadges;
    } catch (error) {
      console.error('Failed to load earned users:', error);
      this.earnedUsers = [];
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  className() {
    return 'BadgeModal';
  }
  title() {
    return this.badge.name();
  }
  content() {
    const totalUsers = app.forum.attribute('userCount') || 1;
    const rarityInfo = getRarityInfo(this.badge.earnedCount(), totalUsers);
    const percentFormatted = formatPercent(rarityInfo.percent);
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "BadgeModal-header"
    }, m("div", {
      className: "BadgeModal-icon",
      style: {
        backgroundColor: this.badge.backgroundColor(),
        color: this.badge.iconColor()
      }
    }, m("i", {
      className: this.badge.icon()
    })), m("div", {
      className: "BadgeModal-info"
    }, m("h2", {
      className: "BadgeModal-name"
    }, this.badge.name()), this.badge.description() && m("p", {
      className: "BadgeModal-description"
    }, this.badge.description()), this.badge.category() && m("span", {
      className: "BadgeModal-category"
    }, m("i", {
      className: "fas fa-folder"
    }), this.badge.category().name()))), m("div", {
      className: "BadgeModal-stats"
    }, m("div", {
      className: "BadgeModal-rarity"
    }, m("div", {
      className: "BadgeModal-rarityInfo"
    }, m("span", {
      className: "BadgeModal-rarityTier BadgeModal-rarityTier--".concat(rarityInfo.tier),
      style: {
        color: rarityInfo.color
      }
    }, m("i", {
      className: "fas fa-gem"
    }), rarityInfo.label), m("span", {
      className: "BadgeModal-earnedCount"
    }, m("i", {
      className: "fas fa-users"
    }), app.translator.trans('fof-badges.forum.earned_by', {
      count: this.badge.earnedCount()
    }))), m("p", {
      className: "BadgeModal-rarityExplain"
    }, app.translator.trans('fof-badges.lib.rarity_explain', {
      percent: percentFormatted
    })))), m("div", {
      className: "BadgeModal-users"
    }, m("h3", {
      className: "BadgeModal-usersTitle"
    }, m("i", {
      className: "fas fa-trophy"
    }), app.translator.trans('fof-badges.forum.earned_users')), this.loading ? m("div", {
      className: "BadgeModal-loading"
    }, m(LoadingIndicator, null)) : this.earnedUsers.length === 0 ? m("div", {
      className: "BadgeModal-noUsers"
    }, m("i", {
      className: "fas fa-user-slash"
    }), m("p", null, app.translator.trans('fof-badges.forum.no_users_earned'))) : m("ul", {
      className: "BadgeModal-userList"
    }, this.earnedUsers.map(ub => {
      const user = ub.user();
      if (!user) return null;
      return m("li", {
        className: "BadgeModal-userItem",
        key: ub.id()
      }, m(Link, {
        href: app.route('user', {
          username: user.username()
        }),
        className: "BadgeModal-userLink"
      }, m(Avatar, {
        user: user
      }), m("span", {
        className: "BadgeModal-userName"
      }, username(user))), m("span", {
        className: "BadgeModal-earnedDate"
      }, humanTime(ub.earnedAt())));
    })), this.earnedUsers.length === 20 && m("div", {
      className: "BadgeModal-moreUsers"
    }, m("p", null, app.translator.trans('fof-badges.forum.more_users_earned')))));
  }
  onremove(vnode) {
    var _this$attrs$onhide, _this$attrs;
    super.onremove(vnode);
    (_this$attrs$onhide = (_this$attrs = this.attrs).onhide) == null || _this$attrs$onhide.call(_this$attrs);
  }
}
flarum.reg.add('fof-badges', 'forum/components/BadgeModal', BadgeModal);